export enum SituacaoContaReceber {
  ABERTA = "ABERTA",
  BAIXADA = "BAIXADA",
  EXCLUIDA = "EXCLUIDA",
  SUBJUDICE = "SUBJUDICE",
  TODAS = "TODAS",
  ABERTA_BAIXADA = "ABERTA_BAIXADA",
}
